export const AG_GRID_GROUP_AUTO_COLUMN_ID = 'ag-Grid-AutoColumn';
